var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.179,
    height: 51.972,
    viewBox: "0 0 58.179 51.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#f4f5f7;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-463.39,1530.137l-18.2-30.282a10.783,10.783,0,0,0-9.317-5.265,10.783,10.783,0,0,0-9.318,5.265l-18.2,30.282a10.708,10.708,0,0,0-.138,10.923,10.75,10.75,0,0,0,9.456,5.5h36.408a10.75,10.75,0,0,0,9.456-5.5A10.7,10.7,0,0,0-463.39,1530.137Z",
    transform: "translate(520 -1494.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-464.178,1541.144h-35.928a10.581,10.581,0,0,1-9.33-5.5,10.829,10.829,0,0,1,.135-10.923l17.868-30.122a10.614,10.614,0,0,0-9.057,5.261l-17.964,30.284a10.831,10.831,0,0,0-.136,10.923,10.582,10.582,0,0,0,9.331,5.5h35.928a10.578,10.578,0,0,0,9.285-5.426C-464.09,1541.14-464.133,1541.144-464.178,1541.144Z",
    transform: "translate(520 -1494.596)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.068 16.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-467.659,1534.411a2.394,2.394,0,0,1-2.476-2.3V1518.3a2.394,2.394,0,0,1,2.476-2.3,2.394,2.394,0,0,1,2.476,2.3v13.807A2.394,2.394,0,0,1-467.659,1534.411Z",
    transform: "translate(470.136 -1516.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-464.862,1565.546a2.777,2.777,0,0,1-2.477,3,2.775,2.775,0,0,1-2.476-3,2.776,2.776,0,0,1,2.476-3A2.777,2.777,0,0,1-464.862,1565.546Z",
    transform: "translate(469.816 -1542.546)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.38dcc86ebd84e74529faa4e037cc4062.svg";
export { ForwardRef as ReactComponent };